import React from "react";

/* ══════════════════════════════════════════════════════════════════
   MARCA — Eixo Auto Control
   ══════════════════════════════════════════════════════════════════

   O símbolo é o chassi visto de cima, como no desenho técnico do manual:
   quatro rodas, eixo dianteiro, cardã e eixo traseiro com o diferencial.
   É o que o mecânico reconhece sem precisar ler — e é literalmente o nome.

   O eixo traseiro (o que traciona) vai em laranja, a cor de sinal do
   sistema. O resto é uma cor só. Nada de degradê, brilho ou volume: o
   desenho tem que aguentar 16px e uma impressora de cupom.

   Grade de 48. As peças não se tocam — a folga de 1,5 entre roda e eixo é
   o que dá cara de desenho de engenharia em vez de ícone de banco de imagem.
*/
const LARANJA = "#E2620C";

function MarcaEixo({ tamanho = 40, tom = "escuro", titulo = "Eixo Auto Control" }) {
  const base = tom === "escuro" ? "#FFFFFF" : "#171C22";
  // O furo do diferencial é furo de verdade (máscara), não um círculo da cor
  // do fundo — assim a marca funciona sobre grafite, branco ou foto.
  const furo = `eixo-furo-${tom}`;
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 48 48" role="img" aria-label={titulo}
      style={{ display: "block", flex: "none" }}>
      <defs>
        <mask id={furo}>
          <rect width="48" height="48" fill="#fff" />
          <circle cx="24" cy="37" r="2.25" fill="#000" />
        </mask>
      </defs>
      {/* rodas */}
      <rect x="4" y="3" width="9" height="16" rx="2" fill={base} />
      <rect x="35" y="3" width="9" height="16" rx="2" fill={base} />
      <rect x="4" y="29" width="9" height="16" rx="2" fill={base} />
      <rect x="35" y="29" width="9" height="16" rx="2" fill={base} />
      {/* eixo dianteiro e cardã */}
      <rect x="14.5" y="9.25" width="19" height="3.5" fill={base} />
      <rect x="22.25" y="14.25" width="3.5" height="15" fill={base} />
      {/* eixo traseiro e diferencial — o que traciona. Redondo, como a
          carcaça de verdade: quadrado cruzado pelo eixo virava um "+" de
          farmácia. */}
      <g mask={`url(#${furo})`} fill={LARANJA}>
        <rect x="14.5" y="35.25" width="19" height="3.5" />
        <circle cx="24" cy="37" r="6.25" />
      </g>
    </svg>
  );
}

/**
 * Símbolo + nome, alinhados pela altura do símbolo.
 *
 * `tamanho` é a altura do símbolo; o texto acompanha na proporção. O
 * "AUTO CONTROL" é espaçado para fechar na largura do "EIXO" — é esse
 * alinhamento que faz parecer marca desenhada, e não um título digitado.
 */
function LogoEixo({ tamanho = 44, tom = "escuro", subtitulo = "Auto Control" }) {
  const corNome = tom === "escuro" ? "#FFFFFF" : "#171C22";
  const corSub = tom === "escuro" ? "#4FAFD1" : "#2C7E9C";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: tamanho * 0.3 }}>
      <MarcaEixo tamanho={tamanho} tom={tom} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}>
        {/* Os espaçamentos foram medidos na Barlow Condensed para as duas
            linhas fecharem na mesma largura. A margem negativa tira o espaço
            que o navegador deixa depois da última letra — sem ela, a
            linha de baixo "sobra" à direita. Tudo é proporcional a
            `tamanho`, então o alinhamento vale em qualquer escala. */}
        <span style={{
          fontFamily: "'Barlow Condensed', 'Barlow', sans-serif", fontWeight: 700,
          fontSize: tamanho * 0.8, lineHeight: 0.8, letterSpacing: "0.06em", marginRight: "-0.06em",
          color: corNome, textTransform: "uppercase",
        }}>Eixo</span>
        <span style={{
          fontFamily: "'Barlow Condensed', 'Barlow', sans-serif", fontWeight: 600,
          fontSize: tamanho * 0.2, lineHeight: 1, letterSpacing: "0.17em", marginRight: "-0.17em",
          color: corSub, textTransform: "uppercase", marginTop: tamanho * 0.12,
          whiteSpace: "nowrap",
        }}>{subtitulo}</span>
      </div>
    </div>
  );
}

export { MarcaEixo, LogoEixo };
